export default "__VITE_ASSET__f84f8cca__"